import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { HeaderInner } from "../../_shared/components/email/email-templates/_shared/components/header-inner";
import { QuestionPlanEmailTemplates } from "../../_shared/components/email/email-templates/email-template";

import type { DayTripPlanI18nCategoriesAndManagerStore } from "../../_store/categories";

type Props = {
	email: DayTripPlanI18nCategoriesAndManagerStore["email"];
	hotelID: string;
	planID: string;
	hotelEmailAddress: string;
};

export const QuestionPlanEmail = ({ email, hotelID, planID, hotelEmailAddress }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="メール設定" categoryStore={email}>
				<HeaderInner hotelID={hotelID} planID={planID} />
			</FeatureIslandMainWithCategoryWrapper>
			<QuestionPlanEmailTemplates email={email} hotelEmailAddress={hotelEmailAddress} />
		</>
	);
};

QuestionPlanEmail.displayName = "QuestionPlanEmail";
